import styled from 'styled-components';
import { textStyle, color } from 'styled-system';

// Example of a general purpose Box layout component
export const Header = styled.h1`
    font-family: sans-serif;
    border-left: 3px solid #ee0606;
    text-transform: uppercase;
    font-size: 16px;
    padding-left: 5px;
    text-align: left;
    // color: rgb(40, 40, 45);
`;

export const Header2 = styled.h2`
    width: 250px;
    font-family: sans-serif;
    color: rgb(40, 40, 45);
    font-size: 43px;
    width: 100%;
    margin: 0px;
`;

export const Label = styled.label`
    ${textStyle};
    ${color};
    text-transform: ${props => props.textransform};
    display: ${props => props.display};
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Text.js